module.exports = __webpack_public_path__ + "img/spinner.edae7ca3.svg";